import { render, staticRenderFns } from "./wechatInstall.vue?vue&type=template&id=d33b8a48&scoped=true&"
import script from "./wechatInstall.vue?vue&type=script&lang=js&"
export * from "./wechatInstall.vue?vue&type=script&lang=js&"
import style0 from "./wechatInstall.vue?vue&type=style&index=0&id=d33b8a48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33b8a48",
  null
  
)

component.options.__file = "wechatInstall.vue"
export default component.exports